import { Component } from '@angular/core';
import { Card, StateService } from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent {
  collapsed = false;
  public subs: Subscription[] = [];

  public topMenu: Card[] = [
    {
      title: 'navigation.home',
      icon: 'home-outline',
      subtitle: '',
      routerLink: '/mainview/home',
    },
    {
      title: 'constructionSites.title',
      icon: 'construct-outline',
      subtitle: '',
      routerLink: '/mainview/construction-sites',
    },
    /*{
      title: 'Kalender',
      icon: 'calendar-outline',
      subtitle: '',
      routerLink: '/mainview/calendar',
    },*/
    {
      title: 'hours.workTime',
      icon: 'time-outline',
      subtitle: '',
      routerLink: '/mainview/hours-overview',
    },
    {
      title: 'reports.title',
      icon: 'clipboard-outline',
      subtitle: '',
      routerLink: '/mainview/construction-day-report-overview',
    },
    {
      title: 'absence.overview',
      icon: 'sunny-outline',
      subtitle: '',
      routerLink: '/mainview/absence-overview',
    },
    {
      title: 'machinery.title',
      icon: 'boat-outline',
      subtitle: '',
      routerLink: '/mainview/machinery-overview',
    },
    {
      title: 'files.title',
      icon: 'folder-outline',
      subtitle: '',
      routerLink: '/mainview/files',
    },
    /*,
    {
      title: 'Rapportberichte',
      icon: 'document-text-outline',
      subtitle: '',
      routerLink: '/mainview/rapport-overview',
    },*/
  ];

  bottomMenu = [
    {
      title: 'settings.title',
      icon: 'settings-outline',
      subtitle: '',
      routerLink: '/mainview/settings',
    },
  ];

  constructor(private state: StateService) {}

  async ngOnInit(): Promise<void> {
    this.collapsed =
      (await this.state.readFromSecureStorage(this.state.SIDEBARCOLLAPSED)) ==
      '1';
    this.subs.push(
      this.state.usrType$.subscribe((x) => {
        if (this.state.isOfficeUser) {
          if (
            this.topMenu.find((x) => x.title == 'user.type.employee') == null
          ) {
            this.topMenu.push({
              title: 'user.type.employee',
              icon: 'people-outline',
              subtitle: '',
              routerLink: '/mainview/user',
            });
          }
        }
      })
    );
  }

  logout() {
    this.state.logout();
  }

  async toggleSidebar() {
    this.collapsed = !this.collapsed;
    await this.state.saveToSecureStorage(
      this.state.SIDEBARCOLLAPSED,
      this.collapsed ? '1' : '0'
    );
  }
}
